import Components from './components/';
import Services from './services/';

export default angular.module('webPublicClient.creditRequest.shared', [
  Components.name,
  Services.name
]);



// WEBPACK FOOTER //
// ./src/credit-request/shared/index.js